import { actionTypesEnum } from '../enum';

export const cabys = (state = null, action) => {

  if (action.type === actionTypesEnum.getCabys) {
    return action.payload;
  }

  return state;
};

export const inventario = (state = null, action) => {

  if (action.type === actionTypesEnum.getInventario) {
    return action.payload;
  }

  return state;
};


export const searchCabys = (state = null, action) => {

  if (action.type === actionTypesEnum.searchCabys) {
    return action.payload;
  }

  return state;
};